var _excluded = ["quantity", "stockMessage", "status", "theme"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { withTheme } from 'styled-components';
import Icon from '../Icon';
import { LoadingIcon, ErrorIcon, SuccessIcon, WarningIcon } from '../Icons';
import StyledSpan from './style';
var settings = {
  inStock: {
    icon: {
      as: SuccessIcon,
      color: 'success',
      size: 'sz24'
    },
    text: {
      color: 'success',
      fontWeight: 'medium'
    }
  },
  outOfStock: {
    icon: {
      as: ErrorIcon,
      color: 'alert',
      size: 'sz16'
    },
    text: {
      color: 'primary',
      fontWeight: 'normal'
    }
  },
  infoUnavailable: {
    icon: {
      as: WarningIcon,
      color: 'unavailable',
      size: 'sz16'
    },
    text: {
      color: 'primary',
      fontWeight: 'normal'
    }
  },
  loading: {
    icon: {
      as: LoadingIcon,
      color: 'loading',
      size: 'sz16'
    },
    text: {
      color: 'primary',
      fontWeight: 'normal'
    }
  }
};
var StockIndicator = function StockIndicator(_ref) {
  var _ref$quantity = _ref.quantity,
    quantity = _ref$quantity === void 0 ? 0 : _ref$quantity,
    stockMessage = _ref.stockMessage,
    status = _ref.status,
    theme = _ref.theme,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(StyledSpan, _extends({
    color: theme.colors.text[settings[status].text.color],
    fontWeight: theme.fonts.fontWeight[settings[status].text.fontWeight]
  }, rest), /*#__PURE__*/React.createElement(Icon, {
    as: settings[status].icon.as,
    color: theme.colors.text[settings[status].icon.color],
    size: settings[status].icon.size
  }), /*#__PURE__*/React.createElement("span", null, stockMessage, " ", quantity > 0 && "(".concat(quantity, ")")));
};
export default withTheme(StockIndicator);